import { Component } from '@angular/core';

@Component({
  selector: 'fgb-games-v2-layout',
  templateUrl: './games-v2-layout.component.html',
  styleUrl: './games-v2-layout.component.scss',
})
export class GamesV2LayoutComponent {}
